<template>
    <div class="p-4 pb-0 w-full">
        <slot />
    </div>
</template>
